import axios from 'axios';

export default function getAhsayUser(user) {
  return new Promise(function (resolve, reject) {
    axios.post('/clientarea.php', {
      action: 'getAhsayUser',
      user: user
    }).then(function (response) {
      if (response.data && response.data.success) {
        reject(response.data);
      } else {
        resolve(response.data);
      }
    }).catch(function (error) {
      resolve(error);
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/components/get_ahsay_user.js